export default __webpack_public_path__ + "static/media/binance-logo.924ce484.svg";